import React from "react";
import PropTypes from "prop-types";
/**
 *
 * @component  SelectField component
 * @description Reusable select field component for form
 *  @param {*props value} getFieldProps
 * @returns option list of select
 */
const SelectFields = (getFieldProps) => {
  // helper props used here only; the rest (formik field props, id, aria-*) go to <select>
  const { fieldName, errors, touched, modalClose, refName, timeZoneList, ...selectProps } =
    getFieldProps;
  return (
    <div
      className={
        errors && touched && errors[fieldName] && touched[fieldName]
          ? "formFieldWrapError"
          : "formFieldWrapInner"
      }
    >
      <select {...selectProps} placeholder="select" ref={refName}>
        <option value={""} className="selectOptions">
          Select
        </option>
        {timeZoneList &&
          timeZoneList.length > 0 &&
          timeZoneList.map((item, i) => {
            return (
              <option value={item.id} className="selectOptions" key={i}>
                {item.displayText}
              </option>
            );
          })}
      </select>
    </div>
  );
};

SelectFields.propTypes = {
  getFieldProps: PropTypes.object,
};

export default SelectFields;
